// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';

import ProxyFile from 'folder-items/ProxyFile';
import EditorActions from 'notebook/protocols/actions/EditorActions';
import EditorStore from 'notebook/protocols/stores/EditorStore';
import {DocumentBanner} from 'notebook/components/banners/DocumentBanner';
import ModelTypeConstants from 'constants/ModelTypeConstants';

// A proxy model that pulls from the EditorStore

class Protocol extends ProxyFile {
  static initClass() {
    this.prototype.proxiedField = 'protocol';
  }

  getStore() {
    return EditorStore;
  }

  getState() {
    return this.getStore().getEditorState(this.id);
  }

  load({deferred}) {
    EditorActions.open(this.id, {deferred});
  }

  openLatestVersion() {
    EditorActions.open(this.id);
  }

  // TODO T3917: refactor notifications and setBanner to use same text
  setBanner() {
    if (!this.isLatest()) {
      this.setBannerText(
        <DocumentBanner.PreviousVersion
          docType={ModelTypeConstants.PROTOCOL}
          isEvaluationPersisted={Boolean(this.proxied()?.note?.noteRuntimeSnapshot?.isEvaluationPersisted)}
          onNavigateToLatest={() => this.openLatestVersion()}
        />
      );
    } else if (!this.writable()) {
      if (this.isArchived()) {
        this.setBannerText(<DocumentBanner.Archived docType={ModelTypeConstants.PROTOCOL} />);
      } else {
        this.setBannerText(<DocumentBanner.ReadOnly docType={ModelTypeConstants.PROTOCOL} />);
      }
    } else {
      this.setBannerText(null);
    }
  }

  setTags(tags) {
    EditorActions.postServerUpdate(this.id, {tags});
  }

  setAuthors(authors) {
    EditorActions.postServerUpdate(this.id, {authors});
  }

  setArchiveRecord(archiveRecord) {
    EditorActions.postServerUpdate(this.id, {archiveRecord});
  }

  setPermissions(permissions) {
    EditorActions.postServerUpdate(this.id, {permissions});
  }

  cleanUp() {
    super.cleanUp();
    EditorActions.close(this.id);
  }
}
Protocol.initClass();

export default Protocol;
